var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardAccountYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 388,
    height: 246,
    viewBox: "0 0 388 246",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M387.837 23.2079V222.302C387.837 235.112 377.439 245.51 364.629 245.51H23.2079C10.3976 245.51 0 235.112 0 222.302V23.2079C0 10.3976 10.3976 0 23.2079 0H364.64C369.224 0 373.51 1.33273 377.094 3.64203C383.551 7.74363 387.837 14.9818 387.837 23.2079Z",
    fill: "url(#paint0_linear_835_42)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M387.835 23.2079V174.381C351.357 188.214 310.238 183.55 300.254 165.983C292.935 153.103 307.86 143.062 303.712 119.303C301.736 108.043 296.554 99.8171 289.167 92.0505C279.275 81.6069 265.407 72.0135 250.115 57.0548C240.281 47.4384 216.177 23.8628 203.033 0H364.627C369.211 0 373.497 1.33273 377.093 3.65353C383.561 7.74364 387.835 14.9703 387.835 23.2079Z",
    fill: "url(#paint1_linear_835_42)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M387.836 75.6091V222.302C387.836 235.112 377.45 245.498 364.64 245.498H23.2072C10.3969 245.498 0.0107422 235.112 0.0107422 222.302V109.663C6.69739 103.045 14.5214 96.8524 23.6323 91.6363C51.4129 75.701 78.2628 76.7695 130.825 79.5383C194.153 82.8702 198.611 93.7158 243.2 95.0945C261.548 95.669 276.484 94.3133 289.168 92.0499C331.919 84.3178 348.854 65.9238 383.24 74.3453C384.768 74.7244 386.297 75.138 387.836 75.6091Z",
    fill: "url(#paint2_linear_835_42)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.475 0C113.156 61.6849 62.5695 110.261 0 113.443V23.2079C0 10.3976 10.3976 0 23.2079 0H119.475Z",
    fill: "url(#paint3_linear_835_42)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M287.891 245.499H124.758L195.232 175.025C201.333 168.936 211.305 168.936 217.406 175.025L287.891 245.499Z",
    fill: "url(#paint4_linear_835_42)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.27,
    d: "M387.837 219.58V222.291C387.837 235.101 377.439 245.499 364.629 245.499H23.2079C10.3976 245.499 0 235.101 0 222.291V130.999C6.43388 127.575 13.8673 124.967 22.1969 124.048C41.4985 121.945 56.6411 129.988 74.4262 139.719C108.537 158.389 113.903 173.152 133.193 185.422C170.303 209.033 200.795 186.468 263.778 188.031C311.227 189.225 361.619 203.702 387.837 219.58Z",
    fill: "url(#paint5_linear_835_42)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.53,
    d: "M387.837 23.2079V222.302C387.837 235.112 377.439 245.51 364.629 245.51H23.2079C10.3976 245.51 0 235.112 0 222.302V23.2079C0 10.3976 10.3976 0 23.2079 0H364.64C369.224 0 373.51 1.33273 377.094 3.64203C383.551 7.74363 387.837 14.9818 387.837 23.2079Z",
    fill: "url(#paint6_linear_835_42)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9599 157.918H33.9394C31.9518 157.918 30.3203 156.286 30.3203 154.299V131.332C30.3203 129.344 31.9518 127.713 33.9394 127.713H64.9599C66.9475 127.713 68.5789 129.344 68.5789 131.332V154.299C68.5789 156.286 66.9475 157.918 64.9599 157.918Z",
    fill: "#F6C859"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0352 153.885C44.8744 153.885 44.7135 153.793 44.6446 153.644C44.5297 153.426 44.6216 153.161 44.8399 153.047C45.4833 152.713 46.3565 152.104 46.862 151.036C47.5054 149.68 47.333 148.21 47.0688 148.083C46.9999 148.049 46.7356 148.187 46.5748 148.267C46.1612 148.485 45.5752 148.773 44.9088 148.543C44.254 148.313 43.9323 147.727 43.7829 147.451C42.7834 145.613 42.4732 140.834 43.5302 138.455C43.8863 137.663 44.3574 137.203 44.9548 137.065C45.5637 136.927 46.0578 137.18 46.4484 137.387C46.7701 137.559 46.9424 137.628 47.0343 137.571C47.4479 137.318 47.4364 135.801 46.862 134.595C46.3565 133.527 45.4833 132.918 44.8399 132.585C44.6216 132.47 44.5412 132.205 44.6446 131.987C44.7595 131.769 45.0237 131.688 45.242 131.792C46.0003 132.182 47.0458 132.918 47.6547 134.216C48.2637 135.491 48.5509 137.686 47.4824 138.329C46.9424 138.651 46.4369 138.386 46.0233 138.18C45.7131 138.019 45.4259 137.869 45.1386 137.938C44.748 138.03 44.4838 138.478 44.3229 138.835C43.3923 140.903 43.6565 145.429 44.5412 147.049C44.6906 147.325 44.8744 147.624 45.1846 147.727C45.4833 147.831 45.759 147.704 46.1612 147.497C46.5518 147.302 46.9884 147.072 47.4479 147.302C48.436 147.785 48.3785 149.922 47.6547 151.438C47.0458 152.725 46.0003 153.472 45.242 153.862C45.1731 153.874 45.1042 153.885 45.0352 153.885Z",
    fill: "#7D662D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7164 139.259H35.743C35.5017 139.259 35.2949 139.064 35.2949 138.811C35.2949 138.559 35.4902 138.363 35.743 138.363H43.7164C43.9577 138.363 44.1645 138.559 44.1645 138.811C44.1645 139.064 43.9577 139.259 43.7164 139.259Z",
    fill: "#7D662D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7164 147.245H35.743C35.5017 147.245 35.2949 147.049 35.2949 146.797C35.2949 146.544 35.4902 146.349 35.743 146.349H43.7164C43.9577 146.349 44.1645 146.544 44.1645 146.797C44.1645 147.049 43.9577 147.245 43.7164 147.245Z",
    fill: "#7D662D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3429 153.885C54.2739 153.885 54.205 153.874 54.1361 153.839C53.3778 153.449 52.3323 152.713 51.7234 151.415C50.9996 149.898 50.9421 147.762 51.9302 147.279C52.3897 147.061 52.8263 147.279 53.2169 147.474C53.6191 147.681 53.8948 147.807 54.1935 147.704C54.5267 147.589 54.722 147.233 54.8369 147.026C55.7216 145.406 55.9858 140.891 55.0552 138.812C54.8943 138.455 54.6186 138.007 54.2395 137.915C53.9982 137.858 53.8488 137.617 53.9063 137.387C53.9637 137.146 54.205 137.008 54.4348 137.054C55.0322 137.192 55.5033 137.663 55.8594 138.455C56.9164 140.834 56.6177 145.613 55.6067 147.451C55.4573 147.727 55.1356 148.313 54.4807 148.543C53.8144 148.773 53.2284 148.485 52.8148 148.267C52.654 148.187 52.3782 148.049 52.3208 148.083C52.0565 148.21 51.8842 149.68 52.5276 151.036C53.0331 152.104 53.9063 152.713 54.5497 153.046C54.768 153.161 54.8484 153.426 54.745 153.644C54.6646 153.793 54.5037 153.885 54.3429 153.885Z",
    fill: "#7D662D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5727 137.49C52.3889 137.49 52.2165 137.375 52.1476 137.192C51.194 134.342 53.4229 132.148 54.1352 131.78C54.3535 131.665 54.6177 131.757 54.7326 131.976C54.8475 132.194 54.7556 132.458 54.5373 132.573C54.2156 132.734 52.1706 134.492 52.9863 136.916C53.0667 137.146 52.9403 137.398 52.7105 137.479C52.6646 137.479 52.6186 137.49 52.5727 137.49Z",
    fill: "#7D662D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6471 139.259H55.6737C55.4324 139.259 55.2256 139.064 55.2256 138.811C55.2256 138.559 55.4209 138.363 55.6737 138.363H63.6471C63.8884 138.363 64.0952 138.559 64.0952 138.811C64.0952 139.064 63.8998 139.259 63.6471 139.259Z",
    fill: "#7D662D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.6471 147.245H55.6737C55.4324 147.245 55.2256 147.049 55.2256 146.797C55.2256 146.544 55.4209 146.349 55.6737 146.349H63.6471C63.8884 146.349 64.0952 146.544 64.0952 146.797C64.0952 147.049 63.8998 147.245 63.6471 147.245Z",
    fill: "#7D662D"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_835_42",
    x1: 42.3858,
    y1: 274.288,
    x2: 345.454,
    y2: -28.7806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#644F14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_835_42",
    x1: 257.947,
    y1: 124.673,
    x2: 378.426,
    y2: 4.19338,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF583"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#644F14"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_835_42",
    x1: 66.4046,
    y1: 298.302,
    x2: 338.466,
    y2: 26.2411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#644F14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_835_42",
    x1: -13.4317,
    y1: 100.007,
    x2: 103.024,
    y2: -16.4481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#644F14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_835_42",
    x1: 165.543,
    y1: 286.284,
    x2: 247.107,
    y2: 204.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDD302"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_835_42",
    x1: 71.7372,
    y1: 303.64,
    x2: 271.818,
    y2: 103.559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#644F14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF583"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_835_42",
    x1: 42.3858,
    y1: 274.288,
    x2: 345.454,
    y2: -28.7806,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDC02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardAccountYellow);
export default __webpack_public_path__ + "static/media/card_account_yellow.e21a090d1dc5b13c7b85a4fc9b49fd18.svg";
export { ForwardRef as ReactComponent };